import Home from '../components/home.jsx'
import './css/homePage.css'

export default function HomePage(){
    return(
        <main className="homePage">            
                <Home />            
        </main>
    )
}